export default __webpack_public_path__ + "static/media/xero_page_four.afb3a41b.svg";